import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input} from "@nextui-org/react";
import { GET } from "../../../../utils/requests";
import { LEASING_TYPES, TYPES } from "../../../../utils/types";
import {Table, TableHeader, TableColumn, TableBody, TableRow, TableCell} from "@nextui-org/react";
import PrintOkayModal from "./printOkay";
import { orders_uri } from "../../../../utils/url";
import ConfOkayModal from "./confOkay";

export default function ConfDetailModal({callback, data}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
  const [datas, setDatas] = useState([]);
  const [allpay, setAllpay] = useState();

  const Get = async () => {
    setLoad(true);
    try{
        const res = await GET(orders_uri+`/userfind?status=${TYPES.CONFIRM}&type=${TYPES.CONFIRM}&phone=${data.user.phone_no}&deposit=${data.user.deposit}&date=${data.date}`);
        setDatas(res.data);
        // setAllpay(res.data.reduce((a,v) =>  a = a + Number(v.pay) , 0 ).toLocaleString());
        setAllpay(
          res.data.reduce((total, item) => total + Number(item.pay * item.too), 0).toLocaleString()
        );
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  const callOpen =()=>{
    onOpen();
    Get();
  }

  const calculateTotalPayment = () => {
    return datas.reduce((total, track) => total + parseFloat(track.pay), 0);
  };

  return (
    <>
      <Button size="sm" className="bg-gray-200 text-gray-600" onPress={callOpen}>Дэлгэрэнгүй</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="5xl">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex justify-between gap-1 font-Roboto">
                <h1>Хүргэлтийн дэлгэрэнгүй мэдээлэл ---  <span className="font-bold text-red-800 2xl">{data.user.phone_no}</span></h1>
                <div className="mr-4">
                  <PrintOkayModal data={data} allpay={calculateTotalPayment()} too={datas.length}/>
                </div>
              </ModalHeader>
              <ModalBody>
                <div className="font-Roboto flex justify-between">
                    <div className="w-full">
                      <Table aria-label="Example static collection table">
                          <TableHeader>
                              <TableColumn>БАРААНЫ НЭР</TableColumn>
                              <TableColumn>БАРААНЫ ҮНЭ</TableColumn>
                              <TableColumn>УТАС/ДАНС</TableColumn>
                              <TableColumn>ТОО ШИРХЭГ</TableColumn>
                              <TableColumn>КОД</TableColumn>
                              <TableColumn>КАРГО ТӨЛБӨР</TableColumn>
                              <TableColumn></TableColumn>
                          </TableHeader>
                          <TableBody>
                              {
                                  datas.map((it, index) => {
                                      return(
                                          <TableRow key={index}>
                                              <TableCell>{it.product.name}</TableCell>
                                              <TableCell>{it.product.price}</TableCell>
                                              <TableCell>{it.phone_or_depo}</TableCell>
                                              <TableCell>{it.too}</TableCell>
                                              <TableCell className="text-xs">{it.too}</TableCell>
                                              <TableCell className="text-xs">{it.pay} <span>{it.leasing === LEASING_TYPES.Y && "Лизинг"}</span></TableCell>
                                              <TableCell>
                                              </TableCell>
                                          </TableRow>
                                      )
                                  })
                              }
                          </TableBody>
                      </Table>
                      {
                          load &&
                          <Spinner/>
                      }
                      <h1 className="m-2 uppercase font-bold text-end">Нийт каргоны төлбөр <span> {allpay} </span></h1>
                    </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Болих
                </Button>
                <ConfOkayModal callback={callback} user={data}/>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}